/*
  Yadegari — motion helper (Oct 2026)
  Names the product photo the shopper clicked so the browser can morph it into the
  product-page gallery (cross-document view transition, see yadegari-motion.css).
  Works on every product card the store renders: homepage cards, Findter grid cards,
  the SEO fallback grid, "You may also like" cards and the stack builder.
  Does nothing in browsers without view transitions or when reduced motion is on.
*/
(function () {
  if (!('startViewTransition' in document)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var NAME = 'yad-hero';
  var CARD_IMAGE =
    '.yhc-product-visual img, ' +
    '.yad-mini-card__media img, ' +
    '.yad-fallback-grid__image img, ' +
    '.search-filters__product-item-grid-view-layout-image img, ' +
    '.yad-stack__choice-media img';

  function clearNames() {
    document.querySelectorAll('[style*="view-transition-name"]').forEach(function (el) {
      el.style.viewTransitionName = '';
    });
  }

  function nameImage(link) {
    var card = link.closest(
      '.yhc-product-card, .yad-mini-card, .yad-fallback-grid__item, .search-filters__product-item, .yad-stack__choice'
    );
    var img = (card || link).querySelector(CARD_IMAGE);
    if (!img) return;
    clearNames();
    // On a product page the gallery photo carries the name from the stylesheet;
    // mute it so only the clicked card is named (two names = no transition).
    document.querySelectorAll('.yad-pdp .product__media img').forEach(function (i) {
      i.style.viewTransitionName = 'none';
    });
    img.style.viewTransitionName = NAME;
  }

  // Name the photo as the shopper clicks through to a product page.
  document.addEventListener(
    'click',
    function (event) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey) return;
      var link = event.target.closest('a[href*="/products/"]');
      if (!link || link.target === '_blank') return;
      nameImage(link);
    },
    true
  );

  // Safety net: if the browser navigates for another reason, make sure at most one
  // element carries the name, so the transition is not skipped.
  window.addEventListener('pageswap', function (event) {
    if (!event.viewTransition) return;
    var named = document.querySelectorAll('[style*="view-transition-name"]');
    if (named.length > 1) clearNames();
  });

  // Coming back from a product page (bfcache or fresh load): drop the stale name,
  // so a second click can morph again.
  window.addEventListener('pageshow', clearNames);
})();